import React from 'react';

const DistributionChart = ({ children, classes, ...props }) => (
  <div className={classes.root} {...props}>
    <div className={classes.container}>{children}</div>
  </div>
);

export default DistributionChart;
